import { ApiStateType, apiDirectCall } from "customHooks/useApi";
import useGetMetadata from "customHooks/useGetMetadata";
import useValuesFromSource from "customHooks/useValuesFromSource";
import { useTranslation } from "react-i18next";
import useCompleoReactHookForm from "customHooks/useCompleoReactHookForm";
import FormModal from "customHooks/useCompleoReactHookForm/components/FormModal";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    DialogActions
} from "@material-ui/core";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { useQueryClient } from "react-query";
import { useState } from "react";
import ShowApiKey from "./ShowApiKey";

interface IModalJobAssessmentsGroupProps {
    open: boolean;
    onClose: () => void;
}
const ModalNewApiKey = (props: IModalJobAssessmentsGroupProps) => {
    const { onClose, open } = props;
    const queryClient = useQueryClient();

    const module = "APIKEYSNEW";
    const [metadata] = useGetMetadata(module);

    const [t, i18n, readyTranslation] = useTranslation(module, {
        useSuspense: false
    });
    const [apiKey, setApiKey] = useState("");

    const [initialValues] = useValuesFromSource(metadata, true, {});

    const ready = readyTranslation && metadata.status === "success";

    const handleSubmit = async (values: any) => {
        const retorno: Compleo.IObject = {};
        retorno.status = 200;
        try {
            const postAddress = `/api-keys/manage-api-keys-new`;
            const returnData = await apiDirectCall(postAddress, "post", values);
            console.log("retorno apiDirectCall", returnData);
            queryClient.invalidateQueries(`/api-keys/manage-api-keys-list`);
            const keyReturn = returnData.data?.apiKey;
            setApiKey(keyReturn);
            // onClose();
        } catch (ex) {
            return ex.response;
        }
        return retorno;
    };
    const postReturn: ApiStateType = {
        status: "success",
        response: {},
        exception: null
    };

    const [formCompleo, finished, handleSubmitRHF] = useCompleoReactHookForm({
        t: t,
        ready: ready,
        i18nV: i18n,
        postMethod: handleSubmit,
        postReturn: postReturn,
        FormType: FormModal,
        metadadosRetorno: metadata,
        valuesFromSource: initialValues,
        formGroupPaperElevation: 0
    });
    let FormReturn: JSX.Element = <Loading />;
    if (finished && ready) {
        FormReturn = apiKey ? (
            <ShowApiKey apiKey={apiKey} t={t} />
        ) : (
            formCompleo
        );
    }
    const handleSave = () => {
        handleSubmitRHF();
    };

    return (
        <Dialog
            fullWidth
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="md"
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
        >
            <DialogTitle id="alert-dialog-title">
                {t("a_FeatureMainDescription")}
            </DialogTitle>
            <DialogContent>{FormReturn}</DialogContent>
            <DialogActions>
                <Button
                    onClick={() => onClose()}
                    color="secondary"
                    // disabled={isUpdating || !pageReady}
                >
                    {t("COMPLEOGENERAL_CLOSE")}
                </Button>
                {!apiKey && (
                    <Button
                        onClick={() => handleSave()}
                        color="primary"
                        // disabled={isUpdating || !pageReady}
                    >
                        {t("COMPLEOGENERAL_SAVE")}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ModalNewApiKey;
